import i18n from "../../i18n";

export enum TargetKind {
  Additive = 0,
  Rate = 1,
  Level = 2,
}

export enum TargetDirection {
  HigherIsBetter = 0,
  LowerIsBetter = 1,
  Band = 2,
  Neutral = 3,
}

export const KIND_LABELS: Record<TargetKind, string> = {
  get [TargetKind.Additive]() {
    return i18n.t("judgement.kind.additive", { ns: "targets" });
  },
  get [TargetKind.Rate]() {
    return i18n.t("judgement.kind.rate", { ns: "targets" });
  },
  get [TargetKind.Level]() {
    return i18n.t("judgement.kind.level", { ns: "targets" });
  },
};

export const DIRECTION_LABELS: Record<TargetDirection, string> = {
  get [TargetDirection.HigherIsBetter]() {
    return i18n.t("judgement.direction.higherIsBetter", { ns: "targets" });
  },
  get [TargetDirection.LowerIsBetter]() {
    return i18n.t("judgement.direction.lowerIsBetter", { ns: "targets" });
  },
  get [TargetDirection.Band]() {
    return i18n.t("judgement.direction.band", { ns: "targets" });
  },
  get [TargetDirection.Neutral]() {
    return i18n.t("judgement.direction.neutral", { ns: "targets" });
  },
};

export interface DataSourceFilterDTO {
  field: string;
  equals?: string;
  notEquals?: string;
  in?: string[];
  notIn?: string[];
  greaterThan?: number;
  greaterThanOrEqual?: number;
  lessThan?: number;
  lessThanOrEqual?: number;
}

export interface TargetFormulaSideDTO {
  expression: string;
  filters?: DataSourceFilterDTO[] | null;
}

export interface TargetFormulaDTO {
  endpoint: string;
  numerator: TargetFormulaSideDTO;
  denominator?: TargetFormulaSideDTO | null;
  scale?: number;
}
